import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";
import { getHelpArticle, createHelpArticleView } from "../../services/helpApi";

const useHelpArticle = (slug) => {
  const [loading, setLoading] = useState(true);
  const [article, setArticle] = useState(null);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      return;
    }

    const fetchArticle = async () => {
      setLoading(true);
      try {
        const { data } = await getHelpArticle(slug);
        setArticle(data);

        // Registrar visualização
        if (data?.id) {
          await createHelpArticleView(data.id);
        }

        setLoading(false);
      } catch (err) {
        setLoading(false);
        toastError(err);
      }
    };

    fetchArticle();
  }, [slug]);

  return { article, loading };
};

export default useHelpArticle;
